import { useEffect, useState } from "react";

import { useWsSubscribe } from "@/ws/WebSocketProvider";

interface TapeEntry {
  id: number;
  time: string;
  text: string;
  tone: "up" | "down" | "info" | "warn";
}

let nextId = 0;
const MAX = 100;

/** Recent fills + alerts, blotter-style. */
export function TapePane() {
  const [entries, setEntries] = useState<TapeEntry[]>([]);

  useWsSubscribe("fill", (msg) => {
    const text = `${msg.side} ${msg.qty} ${msg.symbol} @ ${msg.price}`;
    push({
      id: nextId++,
      time: new Date(String(msg.time ?? Date.now())).toLocaleTimeString(),
      text,
      tone: msg.side === "BUY" ? "up" : "down",
    });
  });

  useWsSubscribe("alert", (msg) => {
    const level = String(msg.level ?? "info");
    push({
      id: nextId++,
      time: new Date().toLocaleTimeString(),
      text: String(msg.message ?? ""),
      tone: level === "error" ? "down" : level === "warning" ? "warn" : level === "success" ? "up" : "info",
    });
  });

  function push(entry: TapeEntry) {
    setEntries((cur) => {
      const next = [entry, ...cur];
      return next.length > MAX ? next.slice(0, MAX) : next;
    });
  }

  // Initial demo line so an empty pane isn't ambiguous.
  useEffect(() => {
    push({ id: nextId++, time: new Date().toLocaleTimeString(), text: "tape connected", tone: "info" });
  }, []);

  return (
    <div className="h-full overflow-y-auto px-2 py-1 text-2xs font-mono">
      {entries.length === 0 ? (
        <p className="px-1 py-2 text-term-mute">Waiting for fills…</p>
      ) : (
        entries.map((e) => (
          <div key={e.id} className="flex gap-2 py-0.5 leading-tight">
            <span className="text-term-mute">{e.time}</span>
            <span
              className={
                e.tone === "up" ? "up" : e.tone === "down" ? "down" : e.tone === "warn" ? "warn" : "text-term-dim"
              }
            >
              {e.text}
            </span>
          </div>
        ))
      )}
    </div>
  );
}
